import React from 'react';
import PropTypes from 'prop-types';
import LoadingSvg from 'common/components/atoms/Loading';
import AnnotationControls from 'home/Annotations/components/AnnotationControls';
import ChartItem from './ChartItem';
import ChartMultilineItem from './ChartMultilineItem';
import Error from '../atoms/Error';

const ChartsViewChartArea = (props) => {
  const {
    annotationsVisible,
    chartLoading,
    chartType,
    config,
    days,
    tag,
    customDayFrom,
    customDayTo,
    amp_type,
    feature,
    bin_nos,
    selection,
    waveAndSpecSelection,
    mouseoverChart,
    refreshChartAfterOutlier,
    selectedRange,
    getWaveAndSpecForId,
    storeBrushSelection,
    brushSelected,
    lastHoveredChart,
    setLastHoveredChart,
    onFeatureDetailsClick,
    openAddEditFeatures,
    openFeature,
    openFeatureDetails,
    closeFeatureDetailsClick,
    featureForDetails,
    featureToOpen,
    filterMin,
    filterMax,
    openEditDemod,
    measurement_type,
    componentNode,
    showBaseline,
    paginationLoading,
    editRULSettings,
    closeRULSettings,
    showOverlay,
    filteredOverlayPoints,
    updateSelectedPoints,
    retryOverlayTraceForPoint,
    spectrumXUnit,
    spectrumYUnit,
    setSpectrumXUnit,
    setSpectrumYUnit,
    toggleSpectrumYUnit,
    updateConfigFeatures,
    waterfallXUnit,
    toggleWaterfallXUnit,
    showCharts,
    loading,
    openOverallAlarm,
    envelopeAlarm,
    previewConfig
  } = props;

  return (
    <>
      {annotationsVisible && chartType === 'trend' && showCharts && (
        <AnnotationControls
          scopeKey={tag ? tag.id : null}
          selectedRange={selectedRange ? `${selectedRange.start} - ${selectedRange.end}` : null}
        />
      )}
      {showCharts && config && !config.default && config.trends_data && config.trends_data.length > 0 && (
        <ChartMultilineItem
          config={config}
          days={days}
          customDayTo={customDayTo}
          customDayFrom={customDayFrom}
        />
      )}
      {config && config.trends_data && config.trends_data.error && !loading && (
        <Error>{config.trends_data.error}</Error>
      )}
      {showCharts && config && tag && config.default && config.trends_data && config.trends_data.length > 0 && (
        <ChartItem
          config={config}
          days={days}
          tag={tag}
          chartType={chartType}
          customDayFrom={customDayFrom}
          customDayTo={customDayTo}
          amp_type={amp_type}
          feature={feature}
          bin_nos={bin_nos}
          selection={selection}
          waveAndSpecSelection={waveAndSpecSelection}
          mouseoverChart={mouseoverChart}
          refreshChartAfterOutlier={refreshChartAfterOutlier}
          selectedRange={selectedRange}
          getWaveAndSpecForId={getWaveAndSpecForId}
          storeBrushSelection={storeBrushSelection}
          brushSelected={brushSelected}
          lastHoveredChart={lastHoveredChart}
          setLastHoveredChart={setLastHoveredChart}
          onFeatureDetailsClick={onFeatureDetailsClick}
          onFeatureEditClick={openAddEditFeatures}
          openFeature={openFeature}
          openFeatureDetails={openFeatureDetails}
          closeFeatureDetailsClick={closeFeatureDetailsClick}
          featureForDetails={featureForDetails}
          featureToOpen={featureToOpen}
          filterMinVal={tag.type === 'vibration' ? filterMin : null}
          filterMaxVal={tag.type === 'vibration' ? filterMax : null}
          openEditDemod={openEditDemod}
          measurement_type={measurement_type}
          componentNode={componentNode}
          showBaseline={showBaseline}
          paginationLoading={paginationLoading}
          editRULSettings={editRULSettings}
          closeRULSettings={closeRULSettings}
          showOverlay={showOverlay}
          selectedPoints={filteredOverlayPoints}
          updateSelectedPoints={updateSelectedPoints}
          retryOverlayTrace={retryOverlayTraceForPoint}
          spectrumXUnit={spectrumXUnit}
          spectrumYUnit={spectrumYUnit}
          setSpectrumXUnit={setSpectrumXUnit}
          setSpectrumYUnit={setSpectrumYUnit}
          toggleSpectrumYUnit={toggleSpectrumYUnit}
          updateConfigFeatures={updateConfigFeatures}
          waterfallXUnit={waterfallXUnit}
          toggleWaterfallXUnit={toggleWaterfallXUnit}
          isVFD={tag && !!tag.no_of_bins}
        />
      )}
      {((!config || !config.trends_data) ||
        (config && config.trends_data && config.trends_data.loading) ||
        (previewConfig && chartLoading)) &&
        !openOverallAlarm &&
        !envelopeAlarm &&
        <LoadingSvg />
      }
    </>
  );
};

/* eslint-disable react/require-default-props */
ChartsViewChartArea.propTypes = {
  annotationsVisible: PropTypes.bool,
  chartLoading: PropTypes.bool,
  chartType: PropTypes.string,
  config: PropTypes.object,
  days: PropTypes.number,
  tag: PropTypes.object,
  customDayFrom: PropTypes.string,
  customDayTo: PropTypes.string,
  amp_type: PropTypes.string,
  feature: PropTypes.string,
  bin_nos: PropTypes.array,
  selection: PropTypes.object,
  waveAndSpecSelection: PropTypes.object,
  mouseoverChart: PropTypes.func,
  refreshChartAfterOutlier: PropTypes.func,
  selectedRange: PropTypes.object,
  getWaveAndSpecForId: PropTypes.func,
  storeBrushSelection: PropTypes.func,
  brushSelected: PropTypes.object,
  lastHoveredChart: PropTypes.any,
  setLastHoveredChart: PropTypes.func,
  onFeatureDetailsClick: PropTypes.func,
  openAddEditFeatures: PropTypes.func,
  openFeature: PropTypes.bool,
  openFeatureDetails: PropTypes.bool,
  closeFeatureDetailsClick: PropTypes.func,
  featureForDetails: PropTypes.object,
  featureToOpen: PropTypes.any,
  filterMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  filterMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  openEditDemod: PropTypes.func,
  measurement_type: PropTypes.number,
  componentNode: PropTypes.object,
  showBaseline: PropTypes.bool,
  paginationLoading: PropTypes.bool,
  editRULSettings: PropTypes.bool,
  closeRULSettings: PropTypes.func,
  showOverlay: PropTypes.bool,
  filteredOverlayPoints: PropTypes.array,
  updateSelectedPoints: PropTypes.func,
  retryOverlayTraceForPoint: PropTypes.func,
  spectrumXUnit: PropTypes.string,
  spectrumYUnit: PropTypes.string,
  setSpectrumXUnit: PropTypes.func,
  setSpectrumYUnit: PropTypes.func,
  toggleSpectrumYUnit: PropTypes.func,
  updateConfigFeatures: PropTypes.func,
  waterfallXUnit: PropTypes.string,
  toggleWaterfallXUnit: PropTypes.func,
  showCharts: PropTypes.bool,
  loading: PropTypes.bool,
  openOverallAlarm: PropTypes.bool,
  envelopeAlarm: PropTypes.bool,
  previewConfig: PropTypes.object
};

export default ChartsViewChartArea;
